import { useTheme } from "vuetify";

export const COLOR_MODE_KEY = "tm-color-mode";

/**
 * Must be called within a synchronous Vue <script setup> block.
 * Do NOT call after any `await`, from a Pinia action, or from outside a component.
 * Reason: useTheme() requires getCurrentInstance() to be non-null.
 */
export const useColorMode = () => {
  const isDark = useState<boolean>("colorMode", () => {
    if (import.meta.client) {
      try {
        return localStorage.getItem(COLOR_MODE_KEY) === "dark";
      } catch {}
    }
    return false;
  });
  const vuetifyTheme = useTheme();

  function apply(dark: boolean) {
    isDark.value = dark;
    if (import.meta.client) {
      document.documentElement.classList.toggle("dark", dark);
      vuetifyTheme.global.name.value = dark ? "darkTheme" : "defaultTheme";
      try {
        localStorage.setItem(COLOR_MODE_KEY, dark ? "dark" : "light");
      } catch {}
    }
  }

  function toggle() {
    apply(!isDark.value);
  }

  function setDark(dark: boolean) {
    apply(dark);
  }

  function init() {
    if (import.meta.client) {
      try {
        apply(localStorage.getItem(COLOR_MODE_KEY) === "dark");
      } catch {}
    }
  }

  return { isDark, toggle, setDark, init };
};
